import chamberViewer1 from './images/chamberViewer/chamber-viewer-1.png';
import chamberViewer2 from './images/chamberViewer/chamber-viewer-2.png';
import chamberViewer3 from './images/chamberViewer/chamber-viewer-3.png';
import type { BaseTourStop } from './tourContextBase';

export enum ChamberViewerTourStops {
  STEP_1 = 'chamberViewer1',
  STEP_2 = 'chamberViewer2',
  STEP_3 = 'chamberViewer3',
  HELP = 'chamberViewerHelp',
}

export type ChamberViewerTourStop = BaseTourStop & {
  id: ChamberViewerTourStops;
};

export const chamberViewerTour: ChamberViewerTourStop[] = [
  {
    id: ChamberViewerTourStops.STEP_1,
    placement: 'left-start',
    text: 'Chamber Profile Viewer enables visualizing chamber profiles, verify mantle and concave alignment, and ensure proper configuration for optimal performance.',
    title: 'Chamber Profile Viewer',
    image: chamberViewer1,
    emphasize: [],
    position: {
      top: '65px',
      right: '120px',
    },
  },
  {
    id: ChamberViewerTourStops.STEP_2,
    placement: 'left-start',
    text: 'Click Run Simulation to apply and reflect the latest changes.',
    title: 'Run Simulation',
    image: chamberViewer2,
    emphasize: [],
    position: {
      top: '65px',
      right: '120px',
    },
  },
  {
    id: ChamberViewerTourStops.STEP_3,
    placement: 'left-start',
    text: 'View chamber profiles segmented by crushing zones to assess performance.',
    title: 'View the results',
    image: chamberViewer3,
    emphasize: [],
    position: {
      top: '65px',
      right: '120px',
    },
  },
  {
    id: ChamberViewerTourStops.HELP,
    placement: 'left-start',
    text: 'Open the Help menu to replay this walkthrough whenever you need a refresher.',
    title: 'Replay the walkthrough anytime',
    emphasize: ['Help menu', 'replay this walkthrough'],
  },
];
